import { totemTypes } from "./totemTypes";

export const cleanOpcionesTotem = () => ({ type: totemTypes.cleanOpciones });
export const getOpcionesTotem = (data) => ({ type: totemTypes.getOpciones, payload: data });
export const insertOpcionTotem = (data) => ({ type: totemTypes.insertOpcion, payload: data });
export const updateOpcionTotem = (data) => ({ type: totemTypes.updateOpcion, payload: data });
export const deleteOpcionTotem = (data) => ({ type: totemTypes.deleteOpcion, payload: data });

export const cleanSubOpcionesTotem = () => ({ type: totemTypes.cleanSubOpciones });
export const getSubOpcionesTotem = (data) => ({ type: totemTypes.getSubOpciones, payload: data });
export const insertSubOpcionTotem = (data) => ({ type: totemTypes.insertSubOpcion, payload: data });
export const updateSubOpcionTotem = (data) => ({ type: totemTypes.updateSubOpcion, payload: data });
export const deleteSubOpcionTotem = (data) => ({ type: totemTypes.deleteSubOpcion, payload: data });

export const cleanRecepcionesTotem = () => ({ type: totemTypes.cleanRecepciones });
export const getRecepcionesTotem = (data) => ({ type: totemTypes.getRecepciones, payload: data });
export const insertRecepcionTotem = (data) => ({ type: totemTypes.insertRecepcion, payload: data });
export const updateRecepcionTotem = (data) => ({ type: totemTypes.updateRecepcion, payload: data });
export const deleteRecepcionTotem = (data) => ({ type: totemTypes.deleteRecepcion, payload: data });

export const cleanRecepcionesUsuarioTotem = () => ({ type: totemTypes.cleanRecepcionesUsuario });
export const getRecepcionesUsuarioTotem = (data) => ({ type: totemTypes.getRecepcionesUsuario, payload: data });

export const cleanSolicitudesRecepcionesUsuarioTotem = () => ({ type: totemTypes.cleanSolicitudesRecepcionesUsuario });
export const getSolicitudesRecepcionesUsuarioTotem = (data) => ({ type: totemTypes.getSolicitudesRecepcionesUsuario, payload: data });
export const insertSolicitudRecepcionUsuarioTotem = (data) => ({ type: totemTypes.insertSolicitudRecepcionUsuario, payload: data });

export const cleanSolicitudesAfiliadosTotem = () => ({ type: totemTypes.cleanSolicitudesAfiliados });
export const getSolicitudesAfiliadosTotem = (data) => ({ type: totemTypes.getSolicitudesAfiliados, payload: data });
export const updateSolicitudAfiliadoTotem = (data) => ({ type: totemTypes.updateSolicitudesAfiliados, payload: data });

export const cleanAfiliadosTotem = () => ({ type: totemTypes.cleanAfiliados });
export const getAfiliadosTotem = (data) => ({ type: totemTypes.getAfiliados, payload: data });

export const cleanTurnosAfiliadosTotem = () => ({ type: totemTypes.cleanTurnosAfiliados });
export const getTurnosAfiliadosTotem = (data) => ({ type: totemTypes.getTurnosAfiliados, payload: data });
export const confirmTurnosAfiliadoTotem = (data) => ({ type: totemTypes.confirmTurnoAfiliados, payload: data });

export const getRecepcionesPisos = (data) => ({ type: totemTypes.getRecepcionPisos, payload: data });

